import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import UrlInput from './UrlInput';
import ThumbnailGrid from './ThumbnailGrid';
import SupportedPlatforms from './SupportedPlatforms';
import { extractThumbnails } from '../utils/thumbnailExtractor';

const ThumbnailDownloader = () => {
  const [url, setUrl] = useState('');
  const [thumbnails, setThumbnails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleExtractThumbnails = async () => {
    if (!url.trim()) {
      setError('Please enter a valid URL');
      return;
    }

    setLoading(true);
    setError('');
    setThumbnails([]);

    try {
      const extractedThumbnails = await extractThumbnails(url);
      setThumbnails(extractedThumbnails);
    } catch (err) {
      setError(err.message || 'Failed to extract thumbnails');
    } finally {
      setLoading(false);
    }
  };

  const handleClearAll = () => {
    setUrl('');
    setThumbnails([]);
    setError('');
  };

  return (
    <div className="max-w-6xl mx-auto space-y-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="bg-white rounded-2xl shadow-xl p-8"
      >
        <UrlInput
          url={url}
          setUrl={setUrl}
          onExtract={handleExtractThumbnails}
          onClear={handleClearAll}
          loading={loading}
          error={error}
        />
      </motion.div>

      <AnimatePresence>
        {thumbnails.length > 0 && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.6 }}
            className="bg-white rounded-2xl shadow-xl p-8"
          >
            <ThumbnailGrid thumbnails={thumbnails} />
          </motion.div>
        )}
      </AnimatePresence>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="bg-white rounded-2xl shadow-xl p-8"
      >
        <SupportedPlatforms />
      </motion.div>
    </div>
  );
};

export default ThumbnailDownloader;